
export const MIN_STRING_LENGTH = 1
export const MAX_TITLE_LENGTH = 100

export const MIN_ITEMS_QUANTITY = 1

export const ALLOWED_SYMBOLS_REGEX = /^[a-zA-Z0-9' _-]*$/;